import { ERROR } from '#action/types';
import { openBackdrop, closeBackdrop } from '#action/backdrop';
import { webPortalApi } from '#config/web-portal-api';
import { getRequestOptions } from '#helper';

function error(e) {
  return {
    type: ERROR,
    payload: e
  };
}

export const downloadFile = (path, fileName) =>
  async dispatch => {
    dispatch(openBackdrop());

    try {
      const res = await fetch(webPortalApi.buildApiUrl(path), getRequestOptions());

      if (!res.ok) {
        const contentType = res.headers.get('content-type');

        if (!contentType || !contentType.includes('application/json')) {
          throw new TypeError('Response is not json');
        }

        throw await res.json();
      }

      const blob = await res.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      a.remove();
    } catch (e) {
      const message = e.error?.message || e.errorMessage || 'Error in download';

      dispatch(
        error({
          message
        })
      );
    } finally {
      dispatch(closeBackdrop());
    }
  };
